import React, { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { Heading2 } from "@/ui2/atoms/Heading";

import {
  CalendarDeleteSeriesModalContent,
  ScheduleDeleteSeriesModal,
} from "./ScheduleDeleteSeriesModal";

import "./styles.scss";

function DeleteRecurringAwayModal({ onCancel, onSubmit, subTitleText }) {
  const [deleteSeries, setDeleteSeries] = useState(undefined);

  const deleteSeriesOnChange = (e) => setDeleteSeries(e.target.value);

  return (
    <ScheduleDeleteSeriesModal
      deleteSeriesValue={deleteSeries}
      disableSubmit={!deleteSeries}
      onCancel={onCancel}
      onCancelText="Keep Away Slot"
      onSubmit={() => onSubmit(deleteSeries)}
      subTitle={subTitleText}
      title="You're deleting recurring away slot"
    >
      <CalendarDeleteSeriesModalContent
        deleteSeriesOnChange={deleteSeriesOnChange}
        deleteSeriesValue={deleteSeries}
      />
    </ScheduleDeleteSeriesModal>
  );
}

function DeleteSingleAwayModal({ onCancel, onSubmit }) {
  return (
    <div className="ScheduleDeleteDialog position-fixed d-flex align-items-center tw:justify-center">
      <div className="tw:flex tw:flex-col tw:gap-2 tw:rounded-xl tw:bg-fill-white tw:p-5 tw:text-center">
        <Heading2 as="h2" size={3}>
          Delete Away Slot
        </Heading2>

        <p className="body-md">Are you sure you want to delete the slot?</p>

        <div className="tw:cols-2 tw:mt-2 tw:grid tw:grid-flow-col tw:gap-4">
          {/* Wrap handlers in arrow functions to prevent Button2 from passing event objects that cause circular structure errors in Redux */}
          <Button2 onPress={() => onSubmit("this_event")} variant="secondary">
            Yes
          </Button2>

          <Button2 onPress={() => onCancel()}>No</Button2>
        </div>
      </div>
    </div>
  );
}

export function ScheduleDeleteAwayModal({ isRecurring, onCancel, onSubmit, subTitleText }) {
  return (
    <>
      {isRecurring && (
        <DeleteRecurringAwayModal
          onCancel={onCancel}
          onSubmit={onSubmit}
          subTitleText={subTitleText}
        />
      )}

      {!isRecurring && <DeleteSingleAwayModal onCancel={onCancel} onSubmit={onSubmit} />}
    </>
  );
}
